import { ShopifyPageService } from './ShopifyPage';
export const shopifyPageService = new ShopifyPageService();
